<script>
import { mapState, mapGetters } from 'vuex';

import Col from './col.vue';
import StateIcon from '../components/StateIcon/index.vue';
import MultiLineText from '../components/MultiLineText/index';

import { deviceContextMenu } from '../utils/contextMenu';

import MultiAlarm from '@/components/dispositionAlarm/multi.vue';
import SingleAlarm from '@/components/dispositionAlarm/single.vue';

import { List } from '@/utils/List';
import { isEmpty } from '@/utils/is';
import { extDevice, isDevice } from '@/utils/deviceUtils';
import { getDeviceTypeImg } from '@/utils/deviceUtils/index';

import mixins from './mixins';

export default {
  mixins: [mixins],
  components: { StateIcon, MultiAlarm, SingleAlarm, Col, MultiLineText },
  data() {
    return {
      title: '--',
      list: []
    };
  },
  computed: {
    ...mapState('device', ['monitorMenuActive', 'monitorConfig']),
    ...mapState('socket', ['deviceIdMap']),
    ...mapState('mqtt', ['alarmData']),
    ...mapGetters('mqtt', ['alarmSnMap']),
    isInline() {
      return !this.monitorConfig.multiColumn;
    },
    deviceMinWidth() {
      if (this.isGroupByPlace) {
        return this.isInline ? 230 : this.monitorConfig.fontSize * 7 * 1.35;
      } else {
        return this.isInline ? 430 : this.monitorConfig.fontSize * 7 * 1.35;
      }
    },
    stateMinWidth() {
      const min = this.monitorConfig.fontSize * 1.35 * 2.2;
      return this.isInline ? Math.max(min * 1.5, 160) : Math.max(min * 2, 120);
    },
    positionMinWidth() {
      return this.monitorConfig.fontSize * 7 * 1.35;
    },
    multiColumn() {
      // return true;
      return this.monitorConfig.multiColumn;
    },
    isGroupByPlace() {
      return this.monitorConfig.groupBy === 'place';
    },
    group() {
      const list = new List(this.list);
      return list.groupBy('deviceType').list;
    },
    posGroup() {
      const list = new List(this.list);

      const res = list.groupBy('dynamicInfoMap.location_desc').list.map(e => {
        if (isEmpty(e.key)) e.key = '其他';
        return e;
      });

      return res;
    },
    tableConfig() {
      const spanConfig = {};
      const data = [];
      const group = this.isGroupByPlace ? this.posGroup : this.group;

      group.forEach(e => {
        const len = data.length;
        if (this.multiColumn) {
          let items = [];
          e.items.forEach((item, index) => {
            item.col2 = null;
            if ((index + 1) % 2 === 0) {
              items.slice(-1)[0].col2 = item;
            } else {
              items.push(item);
            }
          });
          data.push(...items);
          spanConfig[len] = Math.ceil(e.items.length / 2);
        } else {
          data.push(...e.items);
          spanConfig[len] = e.items.length;
        }
      });
      return { spanConfig, data };
    }
  },
  methods: {
    getDeviceTypeImg,
    openContextmenu: deviceContextMenu,
    spanHandler({ rowIndex, columnIndex }) {
      if (columnIndex === 0) {
        const rowspan = this.tableConfig.spanConfig[rowIndex];
        if (rowspan) {
          return {
            rowspan,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },

    handleRightClick(row, column, event) {
      const key = this.isGroupByPlace ? '设备' : '位置';

      const text = this.$t(key);

      if ([text, `${text}2`].includes(column.label)) {
        event.preventDefault();

        const _row = text === column.label ? row : row.col2;

        const sn = _row.sn;
        const deviceType = _row.deviceType;

        if (isEmpty(_row) || isEmpty(sn) || isEmpty(deviceType)) return;

        this.openContextmenu(event, _row);
      }
    },
    handleAlarmIconClick({ sn }) {
      const singleAlarm = this.$refs.singleAlarm;
      const multiAlarm = this.$refs.multiAlarm;
      const alarmList = this.alarmSnMap[sn];

      if (isEmpty(alarmList)) {
        // TODO 无报警数据处理
        return;
      }

      if (alarmList.length === 1) {
        singleAlarm.show();
        singleAlarm.setData(alarmList[0]);
      } else {
        multiAlarm.show();
        multiAlarm.setTableData(alarmList);
      }
    },
    monitorMenuActiveChange(n) {
      if (isEmpty(n)) return;
      let res;
      let root = null;
      if (isDevice(n.nodeType)) {
        const device = this.deviceIdMap[n.id];
        root = this.deviceIdMap[device.parentId];
      } else {
        root = this.deviceIdMap[n.id];
      }
      res = extDevice([root]);
      this.title = root?.name;
      this.list.splice(0, Infinity, ...res);
    },
    alarmDataHandler(n) {
      const list = Object.values(n);
      if (isEmpty(list)) return;
      const el = document.querySelector(`#sn-${list[0].sn}`);
      if (!isEmpty(el)) el.scrollIntoView(true);
    }
  },
  watch: {
    monitorMenuActive: {
      handler: 'monitorMenuActiveChange',
      immediate: true
    },
    'monitorConfig.fontSize'() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    'monitorConfig.multiColumn'() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    'monitorConfig.groupBy'() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
    alarmData: {
      handler: 'alarmDataHandler',
      deep: true
    }
  }
};
</script>

<style lang="scss">
.device-monitor_list {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;

  width: 100%;
  height: 100%;
  padding: 0 36px;

  box-sizing: border-box;

  .title {
    text-align: center;
    font-size: var(--font-size);
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: var(--monitor-table-title-color, #b1fffc);

    padding: 24px 0;
  }

  .subway-table {
    user-select: none;
    font-size: var(--font-size);
    font-family: Source Han Sans CN;
    font-weight: 400;

    .el-table__header thead {
      color: var(--monitor-table-header-color, #b1fffc);
    }
    .el-table__body {
      height: 100%;
      color: var(--monitor-table-body-color, #00eeff);

      .state-col {
        padding: unset;
        .cell {
          padding: unset;
          height: 100%;

          display: flex;
          align-items: center;
          justify-content: center;

          padding: 15px 0;
        }
      }
    }
    .cell {
      line-height: 1.6;
    }
    tbody tr:hover > td {
      background-color: transparent !important;
    }

    .col-flex {
      line-height: 1.2;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: calc(var(--font-size) * 0.9);
        height: calc(var(--font-size) * 0.9);
        margin-right: 15px;
      }
    }

    &.el-table--border {
      border: 2px solid var(--monitor-table-border-color, #489cd6) !important;

      .el-table__header-wrapper::before {
        content: '';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;

        width: 100%;
        border-image: linear-gradient(
            to right,
            transparent 0%,
            transparent 40%,
            #9ce2e2 50%,
            transparent 60%,
            transparent 100%
          )
          10 !important;
        border-top: 6px solid;
      }

      .el-table__body-wrapper {
        position: unset;
        &::before {
          content: '';
          position: absolute;
          left: 0;
          bottom: -1px;
          z-index: 9;
          width: 100%;
          border-image: linear-gradient(
              to right,
              transparent 0%,
              transparent 40%,
              #9ce2e2 50%,
              transparent 60%,
              transparent 100%
            )
            10 !important;
          border-bottom: 6px solid;
        }
      }

      td,
      th,
      .el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
        border-bottom: 1px solid var(--monitor-table-border-color, #489cd6) !important;
        border-right: 1px solid var(--monitor-table-border-color, #489cd6) !important;
      }
    }
  }

  .device-content {
    display: flex;
    align-items: center;
  }

  .el-table--scrollable-x .el-table__body-wrapper::-webkit-scrollbar,
  .el-table--scrollable-y .el-table__body-wrapper::-webkit-scrollbar {
    width: 12px;
    height: 12px;
  }
}
</style>
